import { Helmet } from "react-helmet";

import { getBrowserFeaturesClasses } from "../../utils/browser-features";

import { useGetBodyClasses, useSetBodyClasses } from "./use-cases/meta_use_cases";

const Meta = ({
  title,
  lang,
  slug,
  description,
  alternateVersions,
  bodyClass,
  disableTranslations,
  noIndex = false,
}) => {
  const bodyClasses = useGetBodyClasses();
  useSetBodyClasses((oldBodyClasses) => [...oldBodyClasses, ...getBrowserFeaturesClasses()]);

  return (
    <>
      <Helmet
        title={title}
        htmlAttributes={{ lang, class: bodyClasses.join(" ") }}
        bodyAttributes={{ class: bodyClass }}
        link={
          slug
            ? [
                {
                  rel: "canonical",
                  href: `${process.env.GATSBY_URL_BASE}/${slug}/`,
                },
              ]
            : []
        }
        meta={[
          ...(description
            ? [
                {
                  name: `description`,
                  content: description,
                },
                {
                  property: `og:title`,
                  content: title,
                },
                {
                  property: `og:description`,
                  content: description,
                },
                {
                  property: `og:type`,
                  content: `website`,
                },
                {
                  name: `twitter:card`,
                  content: `summary`,
                },
                {
                  name: `twitter:creator`,
                  content: `Barkibu`,
                },
                {
                  name: `twitter:title`,
                  content: title,
                },
                {
                  name: `twitter:description`,
                  content: description,
                },
              ]
            : []),
          ...(noIndex ? [{ name: "robots", content: "noindex" }] : []),
        ]}
      />
      {alternateVersions && (
        <Helmet>
          {/* Alternate page versions */}
          {alternateVersions.map(({ id, locale, slug }) => {
            return (
              <link
                key={id}
                rel="alternate"
                href={`${process.env.GATSBY_URL_BASE}/${slug}/`}
                hrefLang={locale}
              />
            );
          })}
          {/* Default page for users worldwide */}
          {alternateVersions
            .filter(({ locale }) => locale === "es")
            .map(({ id, slug }) => (
              <link
                key={id}
                rel="alternate"
                href={`${process.env.GATSBY_URL_BASE}/${slug}/`}
                hrefLang="x-default"
              />
            ))}
        </Helmet>
      )}
      {disableTranslations && (
        <Helmet>
          <meta name="google" content="notranslate" />
        </Helmet>
      )}
    </>
  );
};

export default Meta;
